import React, { useEffect, useState } from "react";
import API_URL from "../../../api/API";
import { useParams, useNavigate } from "react-router-dom";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import Select from "react-select";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import SingleSelectExerciseList from "../../component/SingleSelectExerciseList";
import { GoArrowLeft } from "react-icons/go";
import { MdAdd, MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { RiDeleteBin4Line } from "react-icons/ri";

const DotedSvg = () => {
  return (
    <>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AdminEditStrengthTrainingFocusTemplate = () => {
  const { template_id } = useParams();
  const { staff } = useStaffAuthContext();
  const navigate = useNavigate();

  const [trainingFocus, setTrainingFocus] = useState("");
  const [trainingPhase, setTrainingPhase] = useState("");

  const [trainingFocusData, setTrainingFocusData] = useState(null);
  const [exerciseLibrary, setExerciseLibrary] = useState([]);
  const [selectedExerciseId, setSelectedExerciseId] = useState("");
  const [showAddExerciseForm, setShowAddExerciseForm] = useState(false);
  const [items, setItems] = useState([]);

  const [showAddSupersetForm, setShowAddSupersetForm] = useState(false);
  const [newSupersetTitle, setNewSupersetTitle] = useState("");
  const [selectedSupersetExercises, setSelectedSupersetExercises] = useState({});

  const [showAddCircuitForm, setShowAddCircuitForm] = useState(false);
  const [newCircuitTitle, setNewCircuitTitle] = useState("");
  const [selectedCircuitExercises, setSelectedCircuitExercises] = useState({});

  //reorder top level
  const [reorderMode, setReorderMode] = useState(false);
  const [ssreorderMode, setSSReorderMode] = useState(false);
  const [ccreorderMode, setCCReorderMode] = useState(false);

  // open close exercise
  const [openSuperset, setOpenSuperset] = useState(null);
  const [openCircuit, setOpenCircuit] = useState(null);

  // open close add new exercise
  const [openAddExerciseToCircuit, setOpenAddExerciseToCircuit] = useState(false);
  const [openAddExerciseToSuperset, setOpenAddExerciseToSuperset] = useState(false);

  // Fetch initial template
  const fetchTemplate = async () => {
    try {
      const res = await fetch(`${API_URL.ADMIN_GET_STRENGTH_TEMPLATE_TRAINING_FOCUS}${template_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff?.token}`,
        },
      });
      const data = await res.json();
      if (res.ok) {
        setTrainingFocusData(data.data);
        setItems(data.data.items || []);
        setTrainingFocus(data.data.training_focus || "");
        setTrainingPhase(data.data.training_phase || "");
      }
    } catch (err) {
      console.error("Error fetching template:", err);
    }
  };

  // Fetch exercise library
  const fetchStrengthExerciseData = async () => {
    try {
      const res = await fetch(API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff?.token}`,
        },
      });
      const data = await res.json();
      if (res.ok) {
        // console.log(data.exercises);
        setExerciseLibrary(data.exercises || []);
      } else {
        console.error("Failed to fetch exercise library:", data.message || data.error);
      }
    } catch (err) {
      console.error("Error fetching exercise library:", err);
    }
  };

  const handleAddExercise = async () => {
    if (!selectedExerciseId || !template_id) return;

    const newItem = {
      type: "exercise",
      order_id: items.length + 1,
      exercise: {
        exercise_id: selectedExerciseId,
        sets: [],
      },
    };

    const updatedItems = [...items, newItem];

    try {
      const res = await fetch(`${API_URL.ADMIN_EDIT_STRENGTH_TEMPLATE_TRAINING_FOCUS}${template_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff?.token}`,
        },
        body: JSON.stringify({ items: updatedItems }),
      });

      const data = await res.json();

      if (!data.success) {
        throw new Error(data.message || "Failed to add exercise");
      }

      setItems(data.data.items || []);
      setTrainingFocusData((prev) => ({ ...prev, items: data.data.items }));
      setSelectedExerciseId("");
      setShowAddExerciseForm(false);
    } catch (err) {
      console.error("Error adding exercise:", err);
      alert("Something went wrong while adding the exercise.");
    }
  };

  useEffect(() => {
    fetchTemplate();
    fetchStrengthExerciseData();
  }, []);

  const deleteExercise = (items, setItems, indexToRemove) => {
    const updatedItems = items.filter((_, idx) => idx !== indexToRemove);
    setItems(updatedItems);
  };

  const getExerciseTitle = (exerciseId, exerciseLibrary) => {
    if (typeof exerciseId === "object" && exerciseId?.title) {
      return exerciseId.title;
    }
    const match = exerciseLibrary.find((ex) => ex._id === exerciseId);
    return match ? match.title : "Unknown";
  };

  const getExerciseObject = (exerciseId, exerciseLibrary) => {
    const id = typeof exerciseId === "object" ? exerciseId._id : exerciseId;
    return exerciseLibrary.find((ex) => ex._id === id);
  };

  const addSetToExercise = (items, setItems, idx) => {
    const newSet = {
      reps: "",
      weight: "",
      unit: "%",
      time: "",
      goal: "",
      rest: "",
      notes: "",
    };

    const updatedItems = [...items];
    updatedItems[idx].exercise.sets.push(newSet);
    setItems(updatedItems);
  };

  const editSetInExercise = (items, setItems, idx, setIndex, field, value) => {
    const updatedItems = [...items];
    updatedItems[idx].exercise.sets[setIndex][field] = value;
    setItems(updatedItems);
  };

  const deleteSetFromExercise = (items, setItems, idx, setIndex) => {
    const updatedItems = [...items];
    updatedItems[idx].exercise.sets.splice(setIndex, 1);
    setItems(updatedItems);
  };

  //superset
  const handleAddExerciseToSuperset = ({ idx, items, setItems, selectedSupersetExercises, setSelectedSupersetExercises }) => {
    const exerciseId = selectedSupersetExercises[idx];
    if (!exerciseId) return;

    const updatedItems = [...items];
    const superset = updatedItems[idx].superset;

    superset.exercises.push({
      exercise_id: exerciseId,
      sets: [],
    });

    setItems(updatedItems);
    setSelectedSupersetExercises((prev) => ({
      ...prev,
      [idx]: "",
    }));
  };

  const deleteSuperset = (items, setItems, supersetIndex) => {
    const updatedItems = items
      .filter((_, idx) => idx !== supersetIndex)
      .map((item, index) => ({
        ...item,
        order_id: index + 1, // Reassign order_id to maintain sequence
      }));

    setItems(updatedItems);
  };

  const deleteExerciseFromSuperset = (items, setItems, supersetIdx, exerciseIdx) => {
    const updated = [...items];
    updated[supersetIdx].superset.exercises.splice(exerciseIdx, 1);
    setItems(updated);
  };

  const addSetToSupersetExercise = (items, setItems, supersetIdx, exerciseIdx) => {
    const newSet = {
      reps: "",
      weight: "",
      unit: "%",
      goal: "",
      time: "",
      rest: "",
      notes: "",
    };
    const updated = [...items];
    updated[supersetIdx].superset.exercises[exerciseIdx].sets.push(newSet);
    setItems(updated);
  };

  const deleteSupersetSet = (items, setItems, supersetIdx, exerciseIdx, setIdx) => {
    const updated = [...items];
    updated[supersetIdx].superset.exercises[exerciseIdx].sets.splice(setIdx, 1);
    setItems(updated);
  };

  const editSupersetSetField = (items, setItems, supersetIdx, exerciseIdx, setIdx, field, value) => {
    const updated = [...items];
    updated[supersetIdx].superset.exercises[exerciseIdx].sets[setIdx][field] = value;
    setItems(updated);
  };

  const handleAddSuperset = () => {
    if (!newSupersetTitle.trim()) return;

    const newSuperset = {
      type: "superset",
      order_id: items.length + 1,
      superset: {
        title: newSupersetTitle.trim(),
        exercises: [],
      },
    };

    setItems([...items, newSuperset]);
    setNewSupersetTitle("");
    setShowAddSupersetForm(false);
  };

  //end of superset functions

  //circuit functions
  const handleAddExerciseToCircuit = ({ idx, items, setItems, selectedCircuitExercises, setSelectedCircuitExercises }) => {
    const exerciseId = selectedCircuitExercises[idx];
    if (!exerciseId) return;

    const updatedItems = [...items];
    const circuit = updatedItems[idx].circuit;

    circuit.exercises.push({
      exercise_id: exerciseId,
      sets: [],
    });

    setItems(updatedItems);
    setSelectedCircuitExercises((prev) => ({
      ...prev,
      [idx]: "",
    }));
  };

  const deleteCircuit = (items, setItems, circuitIndex) => {
    const updatedItems = items
      .filter((_, idx) => idx !== circuitIndex)
      .map((item, index) => ({
        ...item,
        order_id: index + 1,
      }));

    setItems(updatedItems);
  };

  const deleteExerciseFromCircuit = (items, setItems, circuitIdx, exerciseIdx) => {
    const updated = [...items];
    updated[circuitIdx].circuit.exercises.splice(exerciseIdx, 1);
    setItems(updated);
  };

  const addSetToCircuitExercise = (items, setItems, circuitIdx, exerciseIdx) => {
    const newSet = {
      reps: "",
      weight: "",
      unit: "%",
      time: "",
      goal: "",
      rest: "",
      notes: "",
    };
    const updated = [...items];
    updated[circuitIdx].circuit.exercises[exerciseIdx].sets.push(newSet);
    setItems(updated);
  };

  const deleteCircuitSet = (items, setItems, circuitIdx, exerciseIdx, setIdx) => {
    const updated = [...items];
    updated[circuitIdx].circuit.exercises[exerciseIdx].sets.splice(setIdx, 1);
    setItems(updated);
  };

  const editCircuitSetField = (items, setItems, circuitIdx, exerciseIdx, setIdx, field, value) => {
    const updated = [...items];
    updated[circuitIdx].circuit.exercises[exerciseIdx].sets[setIdx][field] = value;
    setItems(updated);
  };

  const handleAddCircuit = () => {
    if (!newCircuitTitle.trim()) return;

    const newCircuit = {
      type: "circuit",
      order_id: items.length + 1,
      circuit: {
        title: newCircuitTitle.trim(),
        exercises: [],
      },
    };

    setItems([...items, newCircuit]);
    setNewCircuitTitle("");
    setShowAddCircuitForm(false);
  };

  //end of circuit functions

  const handleSaveTemplate = async () => {
    try {
      const res = await fetch(`${API_URL.ADMIN_EDIT_STRENGTH_TEMPLATE_TRAINING_FOCUS}${template_id}`, {
        method: "POST", // or "PUT", depending on your backend
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${staff?.token}`,
        },
        body: JSON.stringify({
          training_focus: trainingFocus,
          training_phase: trainingPhase,
          items,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        alert("Template saved successfully!");
      } else {
        console.error("Failed to save:", data.message || data.error);
        alert(data.message || "Error saving template");
      }
    } catch (err) {
      console.error("Error saving template:", err);
      alert("Network or server error");
    }
  };

  const handleItemDragEnd = (event) => {
    const { active, over } = event;
    if (!active?.id || !over?.id || active.id === over.id) return;

    const oldIndex = items.findIndex((item, idx) => (item._id || `item-${idx}`) === active.id);
    const newIndex = items.findIndex((item, idx) => (item._id || `item-${idx}`) === over.id);

    if (oldIndex === -1 || newIndex === -1) return;

    const updatedItems = [...items];
    const [movedItem] = updatedItems.splice(oldIndex, 1);
    updatedItems.splice(newIndex, 0, movedItem);

    const reordered = updatedItems.map((item, idx) => ({
      ...item,
      order_id: idx + 1, // Optional: reassign order_id if you're tracking order
    }));

    setItems(reordered);
  };

  const handleSupersetReorderEnd = (event, supersetId) => {
    const { active, over } = event;
    if (!active?.id || !over?.id || active.id === over.id) return;

    setItems((prevItems) => {
      return prevItems.map((item) => {
        if (item.type === "superset" && item._id === supersetId) {
          const exercises = [...item.superset.exercises];
          const oldIndex = exercises.findIndex((ex) => ex._id === active.id);
          const newIndex = exercises.findIndex((ex) => ex._id === over.id);
          if (oldIndex === -1 || newIndex === -1) return item;

          const [moved] = exercises.splice(oldIndex, 1);
          exercises.splice(newIndex, 0, moved);

          return {
            ...item,
            superset: {
              ...item.superset,
              exercises,
            },
          };
        }
        return item;
      });
    });
  };

  const handleCircuitReorderEnd = (event, circuittId) => {
    const { active, over } = event;
    if (!active?.id || !over?.id || active.id === over.id) return;

    setItems((prevItems) => {
      return prevItems.map((item) => {
        if (item.type === "circuit" && item._id === circuittId) {
          const exercises = [...item.circuit.exercises];
          const oldIndex = exercises.findIndex((ex) => ex._id === active.id);
          const newIndex = exercises.findIndex((ex) => ex._id === over.id);
          if (oldIndex === -1 || newIndex === -1) return item;

          const [moved] = exercises.splice(oldIndex, 1);
          exercises.splice(newIndex, 0, moved);

          return {
            ...item,
            circuit: {
              ...item.circuit,
              exercises,
            },
          };
        }
        return item;
      });
    });
  };

  //video functions
  const [videoUrlToPlay, setVideoUrlToPlay] = useState(null);

  const getYouTubeVideoId = (url) => {
    const match = url.match(/(?:youtube\.com.*(?:\/|v=)|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : null;
  };

  const TIME_OPTIONS = [
    ...Array.from({ length: 6 }, (_, i) => `${(i + 1) * 10}s`), // 10s to 60s
    ...Array.from({ length: 5 }, (_, i) => `${i + 1} min`), // 1 min to 5 min
  ];

  if (!trainingFocusData)
    return (
      <div className="p-6">
        <div className="bg-gray-100 text-sm font-normal p-2 rounded-sm">Loading...</div>
      </div>
    );

  return (
    <div className="flex md:h-screen font-inter">
      <StaffSideMenu />
      <div className="max-md:w-full md:flex-1 overflow-y-auto bg-bgBase">
        <div className="bg-white space-y-4 pt-5 pb-3 md:py-6 px-5 md:px-10 xl:px-16 md:sticky md:top-0 md:z-10">
          <div className="w-full max-w-screen-2xl flex max-md:flex-col justify-between">
            <div className="flex max-md:flex-col md:items-center justify-between gap-5">
              <h2 h2 className="text-dark text-lg md:text-2xl font-medium max-md:ml-12">
                Strength Training Workouts
              </h2>
            </div>

            <div className="flex gap-5">
              <button
                onClick={() => navigate(-1)}
                className="text-slate100 font-inter font-normal text-sm leading-tight flex items-center gap-2 hover:underline"
              >
                <GoArrowLeft color="#666666" /> Go Back
              </button>
              <button
                onClick={handleSaveTemplate}
                className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
              >
                Save Template
              </button>
            </div>
          </div>

          {/* Training Focus & Phase */}
          <div className="flex max-lg:flex-col gap-2">
            <div>
              <label className="font-normal text-slate100 text-sm block mb-1">Training Focus:</label>
              <input
                value={trainingFocus}
                onChange={(e) => setTrainingFocus(e.target.value)}
                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
              />
            </div>
            <div>
              <label className="font-normal text-slate100 text-sm block mb-1">Training Phase:</label>
              <input
                value={trainingPhase}
                onChange={(e) => setTrainingPhase(e.target.value)}
                className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
              />
            </div>
          </div>
        </div>

        <div className="px-5 md:px-10 py-10 w-full max-w-screen-2xl">
          <div className="w-full max-w-screen-lg mx-auto bg-white border border-tblBorder rounded-14 p-5 md:p-6">
            <div className="flex flex-col gap-3 pb-6 mb-6 border-b border-tblBorder">
              <h3 className="text-dark font-medium text-xl">Workout Blocks</h3>
              <div className="flex flex-wrap justify-end gap-3">
                <button
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                  onClick={() => setShowAddExerciseForm(true)}
                >
                  <MdAdd color="#000" /> Add Exercise
                </button>

                <button
                  onClick={() => setShowAddSupersetForm(true)}
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                >
                  <MdAdd color="#000" /> Add Superset
                </button>

                <button
                  onClick={() => setReorderMode(!reorderMode)}
                  className={`px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl`}
                >
                  {reorderMode ? (
                    "Back to Editor"
                  ) : (
                    <>
                      <DotedSvg /> Reorder
                    </>
                  )}
                </button>

                <button
                  onClick={() => setShowAddCircuitForm(true)}
                  className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                >
                  <MdAdd color="#000" /> Add Circuit
                </button>
              </div>
            </div>

            {reorderMode ? (
              // This block is outside the main UI fragment
              <div className="p-4 border border-tblBorder bg-white rounded-10">
                <h2 className="text-lg font-medium mb-2">Reorder Mode</h2>
                <DndContext onDragEnd={handleItemDragEnd}>
                  {items.map((item, idx) => {
                    const itemId = item._id || `item-${idx}`;
                    return (
                      <DroppableEX key={itemId} id={itemId}>
                        <DraggableEXItem id={itemId} itemIndex={idx} item={item} />
                      </DroppableEX>
                    );
                  })}
                </DndContext>
              </div>
            ) : (
              <>
                {/* Add Exercise Form */}
                {showAddExerciseForm && (
                  <div className="pb-6">
                    <div className="bg-bgBase p-4 border border-tblBorder rounded-10">
                      <h3 className="block text-sm font-medium mb-2">Add New Exercise</h3>
                      <SingleSelectExerciseList exercises={exerciseLibrary} value={selectedExerciseId} onChange={(val) => setSelectedExerciseId(val)} />

                      <div className="mt-4 flex gap-2 items-end">
                        <button
                          className="px-4 py-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black h-fit"
                          onClick={handleAddExercise}
                        >
                          Add
                        </button>
                        <button
                          className="px-4 py-2 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white h-fit"
                          onClick={() => setShowAddExerciseForm(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {showAddSupersetForm && (
                  <div className="pb-6">
                    <div className="bg-bgBase p-4 border border-tblBorder rounded-10">
                      <div className="flex max-md:flex-wrap gap-2">
                        <div className="w-full">
                          {/* <label className="block text-sm font-medium mb-2">
                            Superset Title
                          </label> */}
                          <input
                            type="text"
                            value={newSupersetTitle}
                            onChange={(e) => setNewSupersetTitle(e.target.value)}
                            placeholder="Enter Superset Title"
                            className="w-full px-3 py-2.5 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
                          />
                        </div>

                        <div className=" flex-none flex gap-2 items-end">
                          <button
                            onClick={handleAddSuperset}
                            className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black h-fit"
                          >
                            Add Superset
                          </button>
                          <button
                            onClick={() => {
                              setShowAddSupersetForm(false);
                              setNewSupersetTitle("");
                            }}
                            className="px-4 py-2.5 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg
                             hover:bg-black hover:text-white h-fit"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {showAddCircuitForm && (
                  <div className="pb-6">
                    <div className="bg-bgBase p-4 border border-tblBorder rounded-10">
                      <div className="flex max-md:flex-wrap gap-2">
                        <div className="w-full">
                          {/* <label className="block text-sm font-medium mb-2">
                            Circuit Title
                          </label> */}
                          <input
                            type="text"
                            value={newCircuitTitle}
                            onChange={(e) => setNewCircuitTitle(e.target.value)}
                            placeholder="Enter Circuit Title"
                            className="w-full px-3 py-2.5 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none"
                          />
                        </div>

                        <div className="flex-none flex gap-2 items-end">
                          <button
                            onClick={handleAddCircuit}
                            className="px-4 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black h-fit"
                          >
                            Add Circuit
                          </button>
                          <button
                            onClick={() => {
                              setShowAddCircuitForm(false);
                              setNewCircuitTitle("");
                            }}
                            className="px-4 py-2.5 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight 
                            rounded-lg hover:bg-black hover:text-white h-fit"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Exercise & Superset List */}
                <div className="space-y-2">
                  {items.length === 0 ? (
                    <div className="bg-gray-100 p-2 rounded-md text-slate100 text-sm font-normal">No items added yet.</div>
                  ) : (
                    [...items]
                      .sort((a, b) => a.order_id - b.order_id)
                      .map((item, idx) => {
                        //Exercise
                        if (item.type === "exercise") {
                          const title = getExerciseTitle(item.exercise.exercise_id, exerciseLibrary);
                          const exerciseObj = getExerciseObject(item.exercise.exercise_id, exerciseLibrary);
                          // console.log("exerciseObj", exerciseObj);
                          return (
                            <details key={idx} className="border border-tblBorder bg-white rounded-10 overflow-hidden group">
                              <summary className="px-4 py-3 bg-tblHead rounded-t-10 font-medium flex max-[430px]:flex-col max-[430px]:items-start justify-between items-center gap-3">
                                <div className="w-full flex  items-center gap-3">
                                  {exerciseObj?.video_url && (
                                    <div className="size-16 flex-none rounded-md border border-tblBorder relative flex items-center">
                                      {/* Thumbnail */}
                                      <img
                                        src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                        alt="Video thumbnail"
                                        className="w-full h-full rounded object-cover"
                                      />

                                      {/* Preview Button */}
                                      <button
                                        className="text-white text-xl absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[2]"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setVideoUrlToPlay(exerciseObj.video_url);
                                        }}
                                      >
                                        ▶
                                      </button>
                                    </div>
                                  )}

                                  <div className="w-full">
                                    <span className="block text-slate100 text-xs font-medium mb-1">Exercise:</span>
                                    <p className="w-full px-2 py-2 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none">
                                      {title}
                                    </p>
                                  </div>
                                </div>
                                <div className="flex-none flex gap-2">
                                  <button
                                    className="p-2 rounded-md hover:bg-gray-200"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      deleteExercise(items, setItems, idx);
                                    }}
                                  >
                                    <RiDeleteBin4Line color="#666666" size={20} />
                                  </button>

                                  <div className="cursor-pointer p-1.5 rounded hover:bg-gray-200 h-fit">
                                    <MdKeyboardArrowUp color="#6A7282" size={24} className="group-open:rotate-180" />
                                  </div>
                                </div>
                              </summary>

                              <div className="p-4 space-y-6 bg-white border-t border-tblBorder">
                                {!item.exercise?.sets?.length ? (
                                  <div className="bg-gray-100 p-2 rounded-md text-slate100 text-sm font-normal">No sets added yet.</div>
                                ) : (
                                  item.exercise.sets.map((set, setIdx) => (
                                    <div key={setIdx} className="space-y-6">
                                      <div className="p-3 flex gap-4 bg-tblHead border border-tblBorder rounded-10">
                                        <div className="flex flex-wrap gap-2 items-end">
                                          {/* Reps */}
                                          <div className="min-w-20 flex-1">
                                            <div className="flex flex-col-reverse gap-2">
                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">reps</label>

                                              <input
                                                type="text"
                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                value={set.reps}
                                                onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "reps", e.target.value)}
                                              />
                                            </div>
                                          </div>

                                          {/* Weight */}
                                          <div className="min-w-20 flex-1">
                                            <div className="flex flex-col-reverse gap-2">
                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">weight</label>

                                              <input
                                                type="text"
                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                value={set.weight}
                                                onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "weight", e.target.value)}
                                              />
                                            </div>
                                          </div>

                                          {/* Unit + Time */}
                                          {/* Unit dropdown */}
                                          <div className="min-w-20 flex-1">
                                            <div className="flex flex-wrap flex-col-reverse gap-2">
                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">unit</label>

                                              <select
                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                value={set.unit}
                                                onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "unit", e.target.value)}
                                              >
                                                <option value="%">%</option>
                                                <option value="hide">hide</option>
                                                <option value="time">time</option>
                                              </select>
                                            </div>
                                          </div>

                                          {/* Time field */}
                                          {set.unit === "time" && (
                                            <div className="min-w-20 flex-1">
                                              <div className="flex flex-col-reverse gap-2">
                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize">time</label>

                                                <input
                                                  type="text"
                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                  value={set.time || ""}
                                                  onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "time", e.target.value)}
                                                  placeholder="Enter time"
                                                />
                                              </div>
                                            </div>
                                          )}

                                          {/* Goal */}
                                          <div className="min-w-20 flex-1">
                                            <div className="flex flex-col-reverse gap-2">
                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">goal</label>

                                              <select
                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                value={set.goal}
                                                onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "goal", e.target.value)}
                                              >
                                                <option value="">&mdash; Goal &mdash;</option>

                                                <option value="< 0.5 m/s (Absolute Strength)">&lt; 0.5 m/s (Absolute Strength)</option>

                                                <option value="0.5 - 0.75 m/s (Accelerative Strength)">0.5 - 0.75 m/s (Accelerative Strength)</option>

                                                <option value="0.75 - 1 m/s (Strength Speed)">0.75 - 1 m/s (Strength Speed)</option>

                                                <option value="1 - 1.3 m/s (Speed Strength)">1 - 1.3 m/s (Speed Strength)</option>

                                                <option value="> 1.3 m/s (Starting Strength)">&gt; 1.3 m/s (Starting Strength)</option>

                                                <option value="> 2 m/s (Speed)">&gt; 2 m/s (Speed)</option>
                                              </select>
                                            </div>
                                          </div>

                                          {/* Rest */}
                                          <div className="min-w-20 flex-1">
                                            <div className="flex flex-col-reverse gap-2">
                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">rest</label>

                                              <input
                                                type="text"
                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                value={set.rest}
                                                onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "rest", e.target.value)}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex items-center gap-2">
                                          <button
                                            className="p-2 rounded-md hover:bg-gray-200"
                                            onClick={() => deleteSetFromExercise(items, setItems, idx, setIdx)}
                                          >
                                            <RiDeleteBin4Line color="#666666" size={20} />
                                          </button>
                                        </div>
                                      </div>
                                      <div className="flex flex-col gap-2">
                                        <label className="block text-slate100 text-xs font-normal capitalize">Notes</label>
                                        <textarea
                                          rows={3}
                                          className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                          value={set.notes}
                                          onChange={(e) => editSetInExercise(items, setItems, idx, setIdx, "notes", e.target.value)}
                                        />
                                      </div>
                                    </div>
                                  ))
                                )}
                                <div className="mt-4 pt-4 border-t border-tblBorder">
                                  <button
                                    className="text-slate100 text-xs font-medium flex items-center gap-2 hover:text-dark"
                                    onClick={() => addSetToExercise(items, setItems, idx)}
                                  >
                                    <MdAdd color="#666666" size={14} /> Add Set
                                  </button>
                                </div>
                              </div>
                            </details>
                          );
                        }
                        // ========= superset =========
                        if (item.type === "superset") {
                          return (
                            <details key={idx} className="group">
                              <summary className="marker:hidden list-none my-6">
                                <div className="flex flex-wrap lg:flex-nowrap items-center gap-3">
                                  <span className="text-slate100 text-xs font-medium uppercase">
                                    {/* {item.order_id}.  */}
                                    Superset: {item.superset.title}
                                  </span>
                                  <div className="cursor-pointer hidden group-open:flex items-center gap-3">
                                    <button
                                      onClick={() => setSSReorderMode((prev) => (prev === item._id ? null : item._id))}
                                      className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                                    >
                                      {ssreorderMode === item._id ? (
                                        "Done Reordering"
                                      ) : (
                                        <>
                                          <DotedSvg /> Reorder
                                        </>
                                      )}
                                    </button>
                                    <button
                                      className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        deleteSuperset(items, setItems, idx);
                                      }}
                                    >
                                      Superset
                                      <RiDeleteBin4Line color="#666666" size={20} />
                                    </button>
                                  </div>
                                  <div className="p-1 rounded hover:bg-gray-200 h-fit flex-none">
                                    <MdKeyboardArrowUp color="#6A7282" size={24} className="group-open:rotate-180" />
                                  </div>
                                  <span className="bg-tblBorder h-px w-full max-lg:hidden"></span>
                                </div>
                              </summary>

                              <div className="space-y-4 bg-white">
                                {ssreorderMode === item._id ? (
                                  <DndContext onDragEnd={(e) => handleSupersetReorderEnd(e, item._id)}>
                                    {item.superset?.exercises?.map((sup, sIdx) => (
                                      <DroppableSSEX key={sup._id} id={sup._id}>
                                        <DraggableSSEXItem id={sup._id} itemIndex={sIdx} item={sup} />
                                      </DroppableSSEX>
                                    ))}
                                  </DndContext>
                                ) : (
                                  <>
                                    {item.superset.exercises.length === 0 ? (
                                      <div className="bg-gray-100 p-2 rounded-md text-slate100 text-sm font-normal">No exercises added yet.</div>
                                    ) : (
                                      item.superset.exercises.map((exercise, exIdx) => {
                                        const title = getExerciseTitle(exercise.exercise_id, exerciseLibrary);
                                        const exerciseObj = getExerciseObject(exercise.exercise_id, exerciseLibrary);
                                        return (
                                          <div key={exIdx} className="border border-tblBorder bg-white rounded-10 overflow-hidden">
                                            <div className="cursor-pointer px-4 py-3 bg-tblHead rounded-t-10 font-medium flex  max-[430px]:flex-col max-[430px]:items-start justify-between items-center gap-3">
                                              <div className="w-full flex items-center gap-3">
                                                {exerciseObj?.video_url && (
                                                  <>
                                                    <div className="size-16 flex-none rounded-md border border-tblBorder relative flex items-center">
                                                      <img
                                                        src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                        alt="Video thumbnail"
                                                        className="w-full h-full rounded object-cover"
                                                      />
                                                      <button
                                                        className="text-white text-xl absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[2]"
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                          setVideoUrlToPlay(exerciseObj.video_url);
                                                        }}
                                                      >
                                                        ▶
                                                      </button>
                                                    </div>
                                                    <div className="w-full">
                                                      <span className="block text-slate100 text-xs font-medium mb-1">Exercise:</span>
                                                      <p className="w-full px-2 py-2 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none">
                                                        {title}
                                                      </p>
                                                    </div>
                                                  </>
                                                )}
                                              </div>

                                              <div className="flex items-center gap-2">
                                                <button
                                                  className="p-2 rounded-md hover:bg-gray-200"
                                                  onClick={() => deleteExerciseFromSuperset(items, setItems, idx, exIdx)}
                                                >
                                                  <RiDeleteBin4Line color="#666666" size={20} />
                                                </button>
                                                {/* toggle on click of this */}
                                                <button
                                                  onClick={() => setOpenSuperset(openSuperset === item._id ? null : item._id)}
                                                  className="p-1 rounded hover:bg-gray-200 h-fit"
                                                >
                                                  {openSuperset === item._id ? (
                                                    <>
                                                      <MdKeyboardArrowUp color="#6A7282" size={24} />
                                                    </>
                                                  ) : (
                                                    <>
                                                      <MdKeyboardArrowDown color="#6A7282" size={24} />
                                                    </>
                                                  )}
                                                </button>
                                              </div>
                                            </div>
                                            {openSuperset === item._id && (
                                              <div className="p-4 space-y-6 bg-white border-t border-tblBorder">
                                                {exercise.sets.length === 0 ? (
                                                  <div className="text-slate100 text-sm font-normal">No sets added yet.</div>
                                                ) : (
                                                  exercise.sets.map((set, setIdx) => (
                                                    <div key={setIdx} className="space-y-6">
                                                      <div className="p-3 flex flex-col gap-4 bg-tblHead border border-tblBorder rounded-10">
                                                        <div className="flex flex-wrap gap-2 items-end">
                                                          {/* Reps */}
                                                          <div className="min-w-20 flex-1">
                                                            <div className="flex flex-wrap flex-col-reverse gap-2">
                                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">reps</label>

                                                              <input
                                                                type="text"
                                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                value={set.reps}
                                                                onChange={(e) =>
                                                                  editSupersetSetField(items, setItems, idx, exIdx, setIdx, "reps", e.target.value)
                                                                }
                                                              />
                                                            </div>
                                                          </div>

                                                          {/* Weight */}
                                                          <div className="min-w-20 flex-1">
                                                            <div className="flex flex-wrap flex-col-reverse gap-2">
                                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">weight</label>

                                                              <input
                                                                type="text"
                                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                value={set.weight}
                                                                onChange={(e) =>
                                                                  editSupersetSetField(items, setItems, idx, exIdx, setIdx, "weight", e.target.value)
                                                                }
                                                              />
                                                            </div>
                                                          </div>

                                                          {/* Unit + Time */}
                                                          <div className="min-w-20 flex-1">
                                                            <div className="flex flex-col-reverse gap-2">
                                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">unit</label>

                                                              <select
                                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                value={set.unit}
                                                                onChange={(e) =>
                                                                  editSupersetSetField(items, setItems, idx, exIdx, setIdx, "unit", e.target.value)
                                                                }
                                                              >
                                                                <option value="%">%</option>
                                                                <option value="hide">hide</option>
                                                                <option value="time">time</option>
                                                              </select>
                                                            </div>
                                                          </div>
                                                          {set.unit === "time" && (
                                                            <div className="min-w-20 flex-1">
                                                              <div className="flex flex-col-reverse gap-2">
                                                                <label className="block text-[#99A1AF] text-xs font-normal capitalize">time</label>

                                                                <select
                                                                  className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                  value={set.time || ""}
                                                                  onChange={(e) =>
                                                                    editSupersetSetField(items, setItems, idx, exIdx, setIdx, "time", e.target.value)
                                                                  }
                                                                >
                                                                  <option value="">Select time</option>

                                                                  {TIME_OPTIONS.map((label) => (
                                                                    <option key={label} value={label}>
                                                                      {label}
                                                                    </option>
                                                                  ))}
                                                                </select>
                                                              </div>
                                                            </div>
                                                          )}

                                                          {/* Goal */}
                                                          <div className="min-w-20 flex-1">
                                                            <div className="flex flex-wrap flex-col-reverse gap-2">
                                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">goal</label>

                                                              <select
                                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                value={set.goal}
                                                                onChange={(e) =>
                                                                  editSupersetSetField(items, setItems, idx, exIdx, setIdx, "goal", e.target.value)
                                                                }
                                                              >
                                                                <option value="">— Goal —</option>

                                                                <option value="< 0.5 m/s (Absolute Strength)">&lt; 0.5 m/s (Absolute Strength)</option>

                                                                <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                  0.5 - 0.75 m/s (Accelerative Strength)
                                                                </option>

                                                                <option value="0.75 - 1 m/s (Strength Speed)">0.75 - 1 m/s (Strength Speed)</option>

                                                                <option value="1 - 1.3 m/s (Speed Strength)">1 - 1.3 m/s (Speed Strength)</option>

                                                                <option value="> 1.3 m/s (Starting Strength)">&gt; 1.3 m/s (Starting Strength)</option>

                                                                <option value="> 2 m/s (Speed)">&gt; 2 m/s (Speed)</option>
                                                              </select>
                                                            </div>
                                                          </div>

                                                          {/* Rest */}
                                                          <div className="min-w-20 flex-1">
                                                            <div className="flex flex-wrap flex-col-reverse gap-2">
                                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">rest</label>

                                                              <input
                                                                type="text"
                                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                value={set.rest}
                                                                onChange={(e) =>
                                                                  editSupersetSetField(items, setItems, idx, exIdx, setIdx, "rest", e.target.value)
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                          <button
                                                            className="p-2 rounded-md hover:bg-gray-200 h-fit"
                                                            onClick={() => deleteSupersetSet(items, setItems, idx, exIdx, setIdx)}
                                                          >
                                                            <RiDeleteBin4Line color="#666666" size={20} />
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <div className="flex flex-col gap-2">
                                                        <label className="block text-slate100 text-xs font-normal capitalize">Notes</label>
                                                        <textarea
                                                          rows={3}
                                                          className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                          value={set.notes}
                                                          onChange={(e) => editSupersetSetField(items, setItems, idx, exIdx, setIdx, "notes", e.target.value)}
                                                        />
                                                      </div>
                                                    </div>
                                                  ))
                                                )}

                                                <div className="mt-4 pt-4 border-t border-tblBorder">
                                                  <button
                                                    className="text-slate100 text-xs font-medium flex items-center gap-2 hover:text-dark"
                                                    onClick={() => addSetToSupersetExercise(items, setItems, idx, exIdx)}
                                                  >
                                                    <MdAdd color="#666666" size={14} />
                                                    Add Set
                                                  </button>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })
                                    )}

                                    <button
                                      onClick={() => setOpenAddExerciseToSuperset(true)}
                                      className="text-slate100 font-normal text-sm hover:text-dark flex items-center gap-2"
                                    >
                                      <MdAdd color="#666" /> Add Exercise
                                    </button>

                                    {/* Add Exercise Dropdown */}
                                    {openAddExerciseToSuperset && (
                                      <>
                                        <div className="bg-tblHead p-4 rounded-14 border border-tblBorder mt-4">
                                          <div className="w-full flex flex-wrap items-end gap-3">
                                            {/* <label className="block text-xs mb-1 font-medium">Select Exercise</label> */}
                                            <SingleSelectExerciseList
                                              exercises={exerciseLibrary}
                                              value={selectedSupersetExercises[idx] || ""}
                                              onChange={(val) =>
                                                setSelectedSupersetExercises({
                                                  ...selectedSupersetExercises,
                                                  [idx]: val,
                                                })
                                              }
                                            />

                                            <div className="flex gap-2">
                                              <button
                                                className="px-6 py-2 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                                onClick={() =>
                                                  handleAddExerciseToSuperset({
                                                    idx,
                                                    items,
                                                    setItems,
                                                    selectedSupersetExercises,
                                                    setSelectedSupersetExercises,
                                                  })
                                                }
                                              >
                                                Add
                                              </button>
                                              <button
                                                onClick={() => setOpenAddExerciseToSuperset(false)}
                                                className="px-4 py-2 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white h-fit"
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </details>
                          );
                        }
                        // ========= circuit =========
                        if (item.type === "circuit") {
                          return (
                            <details key={idx} className="group">
                              <summary className="cursor-pointer marker:hidden list-none my-6">
                                <div className="flex flex-wrap lg:flex-nowrap items-center gap-3">
                                  <div className="flex gap-1">
                                    {/* {item.order_id}. Circuit: {item.circuit.title} */}
                                    {/* <span className="text-slate100 text-xs font-medium uppercase">
                                    Circuit:
                                    </span> */}
                                    <span className="text-slate100 text-xs font-medium uppercase whitespace-normal">
                                      Circuit:&nbsp;
                                      {item.circuit.title}
                                    </span>
                                  </div>

                                  <div className="hidden group-open:flex items-center gap-3">
                                    <button
                                      onClick={() => setCCReorderMode((prev) => (prev === item._id ? null : item._id))}
                                      className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                                    >
                                      {ccreorderMode === item._id ? (
                                        "Done Reordering"
                                      ) : (
                                        <>
                                          <DotedSvg /> Reorder
                                        </>
                                      )}
                                    </button>
                                    <button
                                      className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        deleteCircuit(items, setItems, idx);
                                      }}
                                    >
                                      Circuit
                                      <RiDeleteBin4Line color="#666666" size={20} />
                                    </button>
                                  </div>
                                  {/* toggle on click of this */}
                                  <div className="cursor-pointer p-1.5 rounded hover:bg-gray-200 flex-none h-fit">
                                    <MdKeyboardArrowUp color="#6A7282" size={24} className="group-open:rotate-180" />
                                  </div>
                                  <span className="bg-tblBorder h-px w-full max-lg:hidden"></span>
                                </div>
                              </summary>

                              {/* open close this */}
                              <div className="space-y-4 bg-white">
                                {ccreorderMode === item._id ? (
                                  <DndContext onDragEnd={(e) => handleCircuitReorderEnd(e, item._id)}>
                                    {item.circuit?.exercises?.map((sup, sIdx) => (
                                      <DroppableCCEX key={sup._id} id={sup._id}>
                                        <DraggableCCEXItem id={sup._id} itemIndex={sIdx} item={sup} />
                                      </DroppableCCEX>
                                    ))}
                                  </DndContext>
                                ) : (
                                  <>
                                    {item.circuit.exercises.map((exercise, exIdx) => {
                                      const title = getExerciseTitle(exercise.exercise_id, exerciseLibrary);
                                      const exerciseObj = getExerciseObject(exercise.exercise_id, exerciseLibrary);

                                      return (
                                        <div key={exIdx} className="border border-tblBorder bg-white rounded-10 overflow-hidden">
                                          <div className="cursor-pointer px-4 py-3 bg-tblHead rounded-t-10 font-medium flex max-[430px]:flex-col max-[430px]:items-start justify-between items-center gap-3">
                                            <div className="w-full flex items-center gap-3">
                                              {exerciseObj?.video_url && (
                                                <div className="size-16 flex-none rounded-md border border-tblBorder relative flex items-center">
                                                  <img
                                                    src={`https://img.youtube.com/vi/${getYouTubeVideoId(exerciseObj.video_url)}/0.jpg`}
                                                    alt="Video thumbnail"
                                                    className="w-full h-full rounded object-coverr"
                                                  />
                                                  <button
                                                    className="text-white text-xl absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[2]"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      setVideoUrlToPlay(exerciseObj.video_url);
                                                    }}
                                                  >
                                                    ▶
                                                  </button>
                                                </div>
                                              )}

                                              <div className="w-full">
                                                <span className="block text-slate100 text-xs font-medium mb-1">Exercise:</span>
                                                <p className="w-full px-2 py-2 bg-white border border-black/10 rounded-lg font-inter font-normal text-sm outline-none">
                                                  {title}
                                                </p>
                                              </div>
                                            </div>

                                            <div className="flex items-center gap-2">
                                              <button
                                                className="flex-none p-2 rounded hover:bg-gray-100"
                                                onClick={() => deleteExerciseFromCircuit(items, setItems, idx, exIdx)}
                                              >
                                                <RiDeleteBin4Line color="#666666" size={20} />
                                              </button>
                                              {/* toggle on click of this */}
                                              <button
                                                onClick={() => setOpenCircuit(openCircuit === exercise._id ? null : exercise._id)}
                                                className="p-1 rounded hover:bg-gray-200 h-fit"
                                              >
                                                {openCircuit === exercise._id ? (
                                                  <>
                                                    <MdKeyboardArrowUp color="#6A7282" size={24} />
                                                  </>
                                                ) : (
                                                  <>
                                                    <MdKeyboardArrowDown color="#6A7282" size={24} />
                                                  </>
                                                )}
                                              </button>
                                            </div>
                                          </div>

                                          {openCircuit === exercise._id && (
                                            <div className="p-4 space-y-6 bg-white border-t border-tblBorder">
                                              {exercise.sets.length === 0 ? (
                                                <div className="text-slate100 text-sm font-normal">No sets added yet.</div>
                                              ) : (
                                                exercise.sets.map((set, setIdx) => (
                                                  <div key={setIdx} className="space-y-6">
                                                    <div className="p-3 flex gap-4 bg-tblHead border border-tblBorder rounded-10">
                                                      <div className="flex flex-wrap gap-2 items-end">
                                                        {/* Reps */}
                                                        <div className="min-w-20 flex-1">
                                                          <div className="flex flex-col-reverse gap-2">
                                                            <label className="block text-[#99A1AF] text-xs font-normal capitalize">reps</label>

                                                            <input
                                                              type="text"
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={set.reps}
                                                              onChange={(e) => editCircuitSetField(items, setItems, idx, exIdx, setIdx, "reps", e.target.value)}
                                                            />
                                                          </div>
                                                        </div>

                                                        {/* Weight */}
                                                        <div className="min-w-20 flex-1">
                                                          <div className="flex flex-col-reverse gap-2">
                                                            <label className="block text-[#99A1AF] text-xs font-normal capitalize">weight</label>

                                                            <input
                                                              type="text"
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={set.weight}
                                                              onChange={(e) =>
                                                                editCircuitSetField(items, setItems, idx, exIdx, setIdx, "weight", e.target.value)
                                                              }
                                                            />
                                                          </div>
                                                        </div>

                                                        {/* Unit + Time */}

                                                        <div className="min-w-20 flex-1">
                                                          <div className="flex flex-col-reverse gap-2">
                                                            <label className="block text-[#99A1AF] text-xs font-normal capitalize">unit</label>
                                                            <select
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={set.unit}
                                                              onChange={(e) => editCircuitSetField(items, setItems, idx, exIdx, setIdx, "unit", e.target.value)}
                                                            >
                                                              <option value="%">%</option>
                                                              <option value="hide">hide</option>
                                                              <option value="time">time</option>
                                                            </select>
                                                          </div>
                                                        </div>
                                                        {set.unit === "time" && (
                                                          <div className={`min-w-20 flex-1`}>
                                                            <div className="flex flex-col-reverse gap-2">
                                                              <label className="block text-[#99A1AF] text-xs font-normal capitalize">time</label>

                                                              <select
                                                                className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                                value={set.time || ""}
                                                                onChange={(e) =>
                                                                  editCircuitSetField(items, setItems, idx, exIdx, setIdx, "time", e.target.value)
                                                                }
                                                              >
                                                                <option value=""> Select time </option>

                                                                {TIME_OPTIONS.map((label) => (
                                                                  <option key={label} value={label}>
                                                                    {label}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                            </div>
                                                          </div>
                                                        )}

                                                        {/* Goal */}
                                                        <div className="min-w-20 flex-1">
                                                          <div className="flex flex-col-reverse gap-2">
                                                            <label className="block text-[#99A1AF] text-xs font-normal capitalize">goal</label>

                                                            <select
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={set.goal}
                                                              onChange={(e) => editCircuitSetField(items, setItems, idx, exIdx, setIdx, "goal", e.target.value)}
                                                            >
                                                              <option value="">&mdash; Goal &mdash;</option>

                                                              <option value="< 0.5 m/s (Absolute Strength)">&lt; 0.5 m/s (Absolute Strength)</option>

                                                              <option value="0.5 - 0.75 m/s (Accelerative Strength)">
                                                                0.5 - 0.75 m/s (Accelerative Strength)
                                                              </option>

                                                              <option value="0.75 - 1 m/s (Strength Speed)">0.75 - 1 m/s (Strength Speed)</option>

                                                              <option value="1 - 1.3 m/s (Speed Strength)">1 - 1.3 m/s (Speed Strength)</option>

                                                              <option value="> 1.3 m/s (Starting Strength)">&gt; 1.3 m/s (Starting Strength)</option>

                                                              <option value="> 2 m/s (Speed)">&gt; 2 m/s (Speed)</option>
                                                            </select>
                                                          </div>
                                                        </div>

                                                        {/* Rest */}
                                                        <div className="min-w-20 flex-1">
                                                          <div className="flex flex-col-reverse gap-2">
                                                            <label className="block text-[#99A1AF] text-xs font-normal capitalize">rest</label>

                                                            <input
                                                              type="text"
                                                              className="w-full border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                              value={set.rest}
                                                              onChange={(e) => editCircuitSetField(items, setItems, idx, exIdx, setIdx, "rest", e.target.value)}
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <button
                                                        className="flex-none h-fit p-2 rounded hover:bg-gray-100"
                                                        onClick={() => deleteCircuitSet(items, setItems, idx, exIdx, setIdx)}
                                                      >
                                                        <RiDeleteBin4Line color="#666666" size={20} />
                                                      </button>
                                                    </div>
                                                    <div className="flex flex-col gap-2">
                                                      <label className="block text-slate100 text-xs font-normal capitalize">Notes</label>
                                                      <textarea
                                                        rows={3}
                                                        className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-xs font-inter font-normal leading-none outline-none"
                                                        placeholder="Add notes about this block..."
                                                        placeholder="Add notes about this block..."
                                                        value={set.notes}
                                                        onChange={(e) => editCircuitSetField(items, setItems, idx, exIdx, setIdx, "notes", e.target.value)}
                                                      />
                                                    </div>
                                                  </div>
                                                ))
                                              )}
                                              <div className="mt-4 pt-4 border-t border-tblBorder">
                                                <button
                                                  className="text-slate100 text-xs font-medium flex items-center gap-2 hover:text-dark"
                                                  onClick={() => addSetToCircuitExercise(items, setItems, idx, exIdx)}
                                                >
                                                  <MdAdd color="#666666" size={14} />
                                                  Add Set
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}

                                    {/* Add new exercise dropdown */}
                                    <button
                                      onClick={() => setOpenAddExerciseToCircuit(true)}
                                      className="text-slate100 font-normal text-sm hover:text-dark flex items-center gap-2"
                                    >
                                      <MdAdd color="#666" /> Add Exercise
                                    </button>
                                    {openAddExerciseToCircuit && (
                                      <>
                                        <div className="bg-tblHead p-4 rounded-14 border border-tblBorder mt-4">
                                          <div className="w-full flex flex-wrap items-end gap-3">
                                            <SingleSelectExerciseList
                                              exercises={exerciseLibrary}
                                              value={selectedCircuitExercises[idx] || ""}
                                              onChange={(val) =>
                                                setSelectedCircuitExercises((prev) => ({
                                                  ...prev,
                                                  [idx]: val,
                                                }))
                                              }
                                            />

                                            <div className="flex gap-2">
                                              <button
                                                className="px-3 py-2 flex items-center gap-1 bg-dark text-white font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black"
                                                onClick={() =>
                                                  handleAddExerciseToCircuit({
                                                    idx,
                                                    items,
                                                    setItems,
                                                    selectedCircuitExercises,
                                                    setSelectedCircuitExercises,
                                                  })
                                                }
                                              >
                                                <MdAdd color="#fff" size={18} />
                                                Add
                                              </button>

                                              <button
                                                onClick={() => setOpenAddExerciseToCircuit(false)}
                                                className="px-4 py-2 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-tight rounded-lg hover:bg-black hover:text-white h-fit"
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}
                              </div>
                            </details>
                          );
                        }

                        return null;
                      })
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {videoUrlToPlay && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
          <div className="bg-white p-4 rounded-lg shadow-lg w-11/12 max-w-2xl relative">
            <button onClick={() => setVideoUrlToPlay(null)} className="absolute top-2 right-3 text-xl text-gray-700 hover:text-black">
              ✖
            </button>
            <iframe
              width="100%"
              height="400"
              src={videoUrlToPlay.replace("watch?v=", "embed/")}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Exercise Video"
              className="rounded"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const DraggableEXItem = ({ itemIndex, id, item }) => {
  const navigate = useNavigate();
  const [dragMode, setDragMode] = useState(true);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none",
      }
    : undefined;

  return (
    <div ref={setNodeRef} {...attributes} {...(dragMode ? listeners : {})} style={style} className="bg-white border border-tblBorder p-2 rounded-10">
      {item.type === "exercise" && <h4 className="font-medium text-sm leading-tight m-0">Exercise: {item.exercise?.exercise_id?.title}</h4>}
      {item.type === "superset" && <h4 className="font-medium text-sm leading-tight m-0">Superset: {item.superset?.title}</h4>}
      {item.type === "circuit" && <h4 className="font-medium text-sm leading-tight m-0">Circuit: {item.circuit?.title}</h4>}
    </div>
  );
};

const DroppableEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div ref={setNodeRef} className={`transition-all duration-150 ease-in-out ${isOver ? "bg-gray-100" : ""} px-1 py-1 rounded-md`}>
      {children}
    </div>
  );
};

const DroppableSSEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${isOver ? "bg-gray-100" : ""} px-1 py-1 rounded-md`} // ↓ reduced padding
    >
      {children}
    </div>
  );
};

export const DraggableSSEXItem = ({ itemIndex, id, item }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    ...(transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      transition: "none",
    }),
    marginBottom: "0px", // small gap between items
  };

  return (
    <div ref={setNodeRef} {...attributes} {...listeners} style={style} className="bg-white border border-tblBorder p-2 rounded-10">
      <h4 className="font-medium text-sm leading-tight m-0">{item.exercise_id?.title}</h4>
    </div>
  );
};

const DroppableCCEX = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${isOver ? "bg-gray-100" : ""} px-2 py-1 rounded-md`} // Tight padding
    >
      {children}
    </div>
  );
};

export const DraggableCCEXItem = ({ itemIndex, id, item }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id });

  const style = {
    ...(transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      transition: "none",
    }),
    marginBottom: "0px",
  };

  return (
    <div ref={setNodeRef} {...attributes} {...listeners} style={style} className="bg-white border border-tblBorder p-2 rounded-10">
      <div className="font-medium text-sm leading-tight">{item.exercise_id?.title}</div>
    </div>
  );
};
